import React, { useMemo } from "react"
import { Box, Container } from "@chakra-ui/react"
import { useCore } from "@app/hooks/useCore"

const ProductReviews: React.FC<any> = ({ product }) => {
  const {
    helpers: { decodeShopifyId },
  } = useCore()
  const productId = useMemo(() => decodeShopifyId(product?.id, "Product"), [decodeShopifyId, product?.id])

  return (
    <>
      <div id={"review-anchor"} />
      <Box>
        <Container mt={["75px", "0"]}>
          {/* <Heading size={`h2`} as={`h2`} textAlign={`center`}>
            Customer Reviews
          </Heading> */}
          <div
            className="yotpo-widget-instance"
            data-yotpo-instance-id="432057"
            data-yotpo-product-id={productId}
            data-yotpo-name={product.title}
            data-yotpo-url={`https://purebaby.com.au/products/${product.handle}`}
            data-yotpo-image-url={product?.featuredImage?.originalSrc}
            data-yotpo-price={product?.priceRange?.maxVariantPrice?.amount}
            data-yotpo-currency="AUD"
            data-yotpo-description={product.description}
          />
        </Container>
      </Box>
    </>
  )
}

export default ProductReviews
